"use client";

import { Header } from "@/components/features/shared/Header";
import { usePageLoading } from "@/hooks/usePageLoading.hook";
import { useEffect } from "react";

export default function AuthLayout({
  children, // will be a page or nested layout
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { setIsLoading, setIsAnimating } = usePageLoading();

  // Reset animation state only on initial mount to clear any stale state from previous navigation
  // This prevents stuck animations from previous pages, but allows explicit triggers to work
  useEffect(() => {
    // Only reset on initial mount if there's a stale animation state
    // Allow explicit animations (like button clicks) to work
    const timer = setTimeout(() => {
      // Only reset if no active animation was explicitly triggered
      // Check if DOM indicates page is fully loaded
      const isBusy =
        document.documentElement.classList.contains("nprogress-busy") ||
        !!document.getElementById("nprogress");
      if (!isBusy) {
        // Page is loaded, safe to reset any stale state
        setIsLoading(false);
        setIsAnimating(false);
      }
    }, 100);

    return () => clearTimeout(timer);
    // Only run once on mount, not on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Header />
      {children}
    </div>
  );
}
